import React from "react";
import AdmStudentHostelFee from "../../components/AdminTabs/AdminStudentHostelFee/AdmStudentHostelFee";

const AdminResult = () => {
  return (
    <div>
      <AdmStudentHostelFee />
    </div>
  );
};

export default AdminResult;
